import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { SpinnerLoader } from 'shared/ui'
import type { IFilterValue } from 'widgets/FilterEditor/types/types'
import styles from './styles.module.scss'

type IWidgetHubspotMultiTriggerProps = {
  selectedItems: IFilterValue[]
  showValuesWarning: boolean
  loading: boolean
}

export const WidgetHubspotMultiTrigger: FC<IWidgetHubspotMultiTriggerProps> = observer(
  ({ selectedItems, showValuesWarning, loading }) => {
    const selectedItemsCount = selectedItems.length

    if (loading) return <SpinnerLoader ariaLabel={'WidgetTagsTrigger'} size={16} />

    const labelCount = () => {
      if (!selectedItemsCount) return 'select'

      if (selectedItemsCount === 1) {
        const item = selectedItems[0]

        return item.name
      }

      return `${selectedItemsCount} lists`
    }

    return (
      <div
        className={classNames(styles.selectTriggerComponent, {
          [styles.warning]: showValuesWarning,
        })}
      >
        {labelCount()}
      </div>
    )
  }
)
